import React, { useState, useEffect, useRef } from 'react';
import { FaHeadphonesSimple } from "react-icons/fa6";
import MainBannerImage1 from '../../src/assets/images/banner1.png';
import MainBannerImage2 from '../../src/assets/images/banner2.webp';
import MainBannerImage3 from '../../src/assets/images/banner3.png';
import MainBannerImage4 from '../../src/assets/images/banner4.png';
// import MainBannerImage5 from '../../src/assets/images/banner5.webp';

import '../../src/assets/css/style.css';
import CustomLine from './CustomLine';
import AppoinmentModal from './AppoinmnetModal';
import { Link } from 'react-router-dom';

const HomeBanner = () => {
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [fade, setFade] = useState(false);
    const images = [MainBannerImage1, MainBannerImage2, MainBannerImage3, MainBannerImage4];
    const [isMounted, setIsMounted] = useState(false);

    const stickyButtonRef = useRef(null);

    const handleScroll = () => {
        const stickyButton = stickyButtonRef.current;
        const scrollY = window.scrollY;

        if (stickyButton) {
            if (scrollY > 200) {
                console.log("50%")
                stickyButton.style.bottom = '50%';
            }
        }
    };

    useEffect(() => {
        setIsMounted(true);
        window.addEventListener('scroll', handleScroll);

        return () => {
            window.removeEventListener('scroll', handleScroll);
        };
    }, []);

    const nextSlide = () => {
        setFade(true);
        setTimeout(() => {
            setCurrentIndex((prevIndex) => (prevIndex === images.length - 1 ? 0 : prevIndex + 1));
        }, 2500);
    };

    useEffect(() => {
        const imageInterval = setInterval(nextSlide, 7000);
        return () => clearInterval(imageInterval);
    }, []);

    const handleIndicatorClick = (index) => {
        setCurrentIndex(index);
    };

    useEffect(() => {
        setFade(true);
        const timeout = setTimeout(() => setFade(false), 2500);
        return () => clearTimeout(timeout);
    }, [currentIndex]);

    const openModal = () => {
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
    };


    return (
        <>
            <section className="relative w-full main-padding-mobile pt-4 sm:pt-0 sm:px-0">
                <div className="relative w-full overflow-hidden">
                    <img
                        className="w-full h-[38vh] sm:h-auto object-cover"
                        src={images[currentIndex]}
                        alt="Slide"
                    />
                    <div
                        className={`custom-padding xl-screen-padding absolute inset-0 flex flex-col justify-center text-left text-white buttons-container-space`}
                    >
                        {currentIndex === 0 && (
                            <>
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato block sm:flex items-center slide-left">
                                    <CustomLine />
                                    <span className="ml-0 sm:ml-2">Welcome to Nutrillion</span>
                                </p>
                                <h1 className="custom-padding-bottom text-lg sm:text-xl custom-line-height md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                                    Your Journey Begins<br /> with Understanding Who You Are
                                </h1>
                                <hr className="custom-padding-bottom border-t-2 border-[#6DBE45] w-3/5 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5 sm:block" />
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                                    Focused on What Matters—Your Health
                                </p>
                            </>
                        )}

                        {currentIndex === 1 && (
                            <>
                                <h1 className="mb-4 custom-padding-bottom custom-line-height text-lg sm:text-xl md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                                    A Personal Approach to Wellness
                                </h1>
                                <hr className="custom-padding-bottom border-t-2 border-[#6DBE45] w-3/5 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5 sm:block" />
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                                    Personalized Nutrition for You.
                                </p>
                            </>
                        )}

                        {currentIndex === 2 && (
                            <>
                                <h1 className="custom-padding-bottom text-lg custom-line-height sm:text-xl md:text-xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                                    Empowering You to Unlock<br />Your Genetic Potential
                                </h1>
                                <hr className="custom-padding-bottom border-t-2 border-[#6DBE45] w-3/5 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5 sm:block" />
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                                    Maximize Genetic Strength.
                                </p>
                            </>
                        )}

                        {currentIndex === 3 && (
                            <>
                                <h1 className="custom-padding-bottom custom-line-height text-lg sm:text-xl md:text-2xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                                    Personalised Gene Based<br />Counselling
                                </h1>
                                <hr className="custom-padding-bottom border-t-2 border-[#6DBE45] w-3/5 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5 sm:block" />
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                                    Tailored Wellness Insights.
                                </p>
                            </>
                        )}
                           {/* {currentIndex === 4 && (
                            <>
                                <h1 className="custom-padding-bottom custom-line-height text-lg sm:text-xl md:text-2xl lg:text-4xl font-semibold text-black leading-tight client-text slide-left">
                                    Personalised Gene Based<br />Counselling
                                </h1>
                                <hr className="custom-padding-bottom border-t-2 border-[#6DBE45] w-3/5 sm:w-2/3 md:w-2/5 lg:w-1/3 xl:w-1/4 2xl:w-1/5 sm:block" />
                                <p className="custom-padding-bottom text-[#7C517E] text-md sm:text-md font-lato sm:block slide-left">
                                    Tailored Wellness Insights.
                                </p>
                            </>
                        )} */}
                    </div>

                    <div className="absolute buttons-container flex flex-row space-x-3">
                        <Link to="/service">
                            <button className="bg-gray-800 common-btn-all-second text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]">
                                Read More
                            </button>
                        </Link>

                        <button className="bg-[#8f762c] common-btn-all text-white font-lato text-[10px] sm:text-sm md:text-[12px] px-3 py-1 sm:px-6 sm:py-2 md:px-6 md:py-3 rounded-full w-[120px] sm:w-auto md:w-[150px] lg:w-[120px]"
                            onClick={openModal}>
                            Contact Us
                        </button>
                        <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />

                    </div>

                    {/* <div className="absolute right-4 top-3/4 transform -translate-y-1/2 flex flex-col items-center space-y-2 hidden md:flex">
                        {images.map((_, index) => (
                            <div
                                key={index}
                                className={`w-1 h-4 sm:h-10 md:h-8 ${currentIndex === index ? 'bg-black' : 'bg-gray-400'} cursor-pointer`}
                                onClick={() => handleIndicatorClick(index)}
                            ></div>
                        ))}
                    </div>

                    <div className="absolute left-1/2 bottom-2 transform -translate-x-1/2 sm:hidden flex justify-center w-full px-4">
                        {images.map((_, index) => (
                            <button
                                key={index}
                                onClick={() => setCurrentIndex(index)}
                                className={`w-3 h-3 mx-2 rounded-full ${currentIndex === index ? 'bg-black' : 'bg-gray-400'}`}
                            ></button>
                        ))}
                    </div> */}
                </div>
            </section>


            <div>
                <button
                    ref={stickyButtonRef}
                    type="button"
                    className="sticky-button bg-[#7c517e] text-white text-sm px-3 py-1 md:px-4 md:py-2 mt-2 md:mt-0 w-full cursor-pointer md:w-auto"
                    onClick={openModal}
                >
                    BOOK APPOINTMENT
                </button>

                <AppoinmentModal isOpen={isModalOpen} onClose={closeModal} />
            </div>

            <section className="main-padding-mobile 2xl:custom-padding-xlscreen custom-padding xl-screen-padding custom-padding-bottom md:px-10 grid grid-cols-1 md:grid-cols-12 gap-4 mx-auto z-10 relative mt-6 lg:mt-[-19vh]">
                <div className="md:col-span-4  text-white rounded-t-lg rounded-b-none relative overflow-hidden p-4 br-10 ">
                    <img
                        src={require('../../src/assets/images/image_yellow.png')}
                        alt="Call Background"
                        className="absolute inset-0 w-full h-full object-cover"
                    />
                    <div className="relative z-10 flex flex-col items-center justify-center h-full text-center">
                        <div className="flex items-center mt-0 justify-center">
                            <FaHeadphonesSimple className="text-3xl mr-2" />
                            <h3 className="text-lg font-roboto ">Give Us A Call</h3>
                        </div>
                        <p className="custom-padding-bottom text-lg font-lato custom-">+91 955 743 9399</p>
                        <p className="custom-padding-bottom text-center font-lato">Take the first step towards a healthy life</p>
                        <a href="tel:+91-9557439399">
                            <button
                                className="bg-[] px-4 py-2 font-semibold rounded-full border-1 text-white text-xs common-btn-all"
                                style={{ border: '1px solid #ffffff' }}
                                onMouseEnter={(e) => e.target.style.borderColor = '#7c517e'}
                                onMouseLeave={(e) => e.target.style.borderColor = '#ffffff'}
                            >
                                ENQUIRE TODAY
                            </button>
                        </a>
                    </div>
                </div>

                <div className="md:col-span-8 pl-15 bg-white rounded-lg shadow-lg flex flex-col md:flex-row relative p-4 sm:p-0 md:p-0 lg:p-0 xl:p-0 2xl:p-0 ">
                    <div className="flex-1 pt-80 pb-80">
                        <h3
                            className={`custom-padding-bottom text-h2 font-semibold text-gray-800 client-text ${isMounted ? 'typewriter-effect' : ''
                                }`}
                        >
                            <div>
                                <p className="">
                                    Meet our <span className="text-purple-500 tablet-break">Expert Clinical Dietitians</span>
                                </p>
                            </div>
                        </h3>
                        <p className="custom-padding-bottom font-barlow">
                            <span className="text-[#555555] text-p">Dedicated to counselling you toward </span><br />
                            <span className="text-[#8c678e] text-p">healthier, more balanced lifestyle</span>
                        </p>
                        <a href="https://wa.me/+919557439399" target="_blank" rel="noopener noreferrer">
                            <button className="text-white font-semibold text-sm px-4 py-2 rounded common-btn-all mb-4 sm:mb-0">
                                Get in Touch
                            </button>
                        </a>

                    </div>
                    <div className="flex-1 md:mt-0 md:ml-0 relative mt-4 md:mt-0">
                        <div className="relative">
                            <img
                                src={require('../../src/assets/images/expert.webp')}
                                alt="Appointment"
                                className="h-72 w-full object-cover home-img home-img-border"
                            />
                        </div>
                    </div>
                </div>
            </section>
        </>
    );
};

export default HomeBanner;
